<template>
    <div class="testimonials mx-auto">
        <b-container>
            <b-card class="bg-white">
                <b-breadcrumb class="bg-white" :items="this.breadcrumb_items"></b-breadcrumb>
                <div class="row">
                    <div class="col-md-12 float-right">
                        <div class="row float-right mr-2">
                            <div class="form-check form-check-inline">
                                <b-form-radio-group v-model="selected" type="radio" :options="options" v-on:change="getTestimonials(selected)"></b-form-radio-group>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="card border-0 shadow-none">
                            <!-- /.card-header -->
                            <div class="card-body">
                                <div class="table-responsive">
                                    <table class="table m-0">
                                        <tbody>
                                        <tr v-for="testimonial in this.testimonials">
                                            <td>
                                            <b-card class="testimonial-card-edit">
                                                <b-card-text>
                                            <span v-if="!checkifActivated(testimonial.id)"
                                                  v-html="testimonial.text.slice(0, 500)"></span>
                                                    <a class="btn" v-if="!checkifActivated(testimonial.id)"
                                                       @click="activateReadMore(testimonial.id)">
                                                        <br>Read more...</a>
                                                    <span v-if="checkifActivated(testimonial.id)"
                                                          v-html="testimonial.text + ' -<b>' + testimonial.user_nickname + '</b>'"></span>
                                                </b-card-text>
                                                <b-button-group class="buttons">
                                                    <b-button v-if="scope !== 'approved'"
                                                              v-b-tooltip.hover
                                                              v-bind:title="'Approve this review'"
                                                              variant="outline-success"
                                                              @click="updateReview(testimonial, 'approve')">
                                                        Approve
                                                    </b-button>
                                                    <b-button v-b-tooltip.hover
                                                              v-bind:title="'Delete this review'"
                                                              variant="outline-danger"
                                                              @click="updateReview(testimonial, 'delete')">
                                                        Delete Forever
                                                    </b-button>
                                                </b-button-group>
                                            </b-card>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
            <!-- Loading element -->
            <div id="loading" class="loading" v-if="isLoading">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </b-container>
    </div>
</template>

<script>
export default {
    name: 'testimonials',

    beforeMount() {
        this.getTestimonials("toBeApproved")
    },
    data() {
        return {
            agent: null,
            user: null,
            testimonials: [],
            scope: "toBeApproved",
            isLoading: false,
            activatedArray: [],
            readMoreActivated: false,
            review: {
                isApproved: false
            },
            selected: "toBeApproved",
            breadcrumb_items: [],
            options: [
                { value: "toBeApproved", text: 'Pending'},
                { value: "approved", text: 'Active'}
            ],
        }
    },
    methods: {
        getTestimonials(scope) {
            let _self = this;
            let route = '/api/agents/testimonials/' + this.$route.params.slug + "/" + scope
            axios.get(route)
                .then(response => {
                    _self.agent = response.data.agent;
                    _self.user = response.data.agent.user;
                    _self.testimonials = response.data.testimonials;

                    _self.breadcrumb_items = [
                        {
                            'text': 'Home',
                            'href': "/"
                        },
                        {
                            'text': "My Dashboard",
                            'href': "/admin/dashboard"
                        },
                        {
                            'text': this.scope === "approved" ? "Approved Reviews" : "Pending Reviews",
                            'href': "#"
                        },
                    ];
                });
        },
        toast(message, variant) {
            this.$bvToast.toast(message, {
                title: variant,
                variant: variant,
                solid: true
            })
        },
        checkifActivated(id) {
            return this.activatedArray.includes(id);
        },
        activateReadMore(id) {
            this.activatedArray.push(id);
        },
        updateReview(review, action) {
            let _self = this;

            _self.review = review;

            let route = '/api/agents/testimonial/' + review.id + '/' + action;
            this.$dialog
                .confirm("Really " + action + "?")
                .then(function (dialog) {
                    _self.isLoading = true;
                    axios.put(route)
                        .then(function (response) {
                            if (response.data.status === false) {
                                _self.isLoading = false;
                                _self.toast("We're very sorry but there has been an error. Please try again later.", "error", 'danger');
                            } else {
                                _self.isLoading = false;
                                _self.toast('Review status saved!', 'success');
                                location.reload();
                            }
                        });
                })
        },
    },
    computed: {
        testimonial_type () {
            return this.scope == "toBeApproved" ? "Pending Reviews" : "Approved Reviews"
        }
    }
}
</script>

<style lang="scss">
#loading {
    background: rgba(255, 255, 255, 0.6);
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 10010;
    top: 0;
    left: 0;
    text-align: center;
}

#loading i {
    Position: absolute;
    Top: 50%;
    Transform: translateY(-50%);
}

.top-right {
    position: absolute;
    top: 5px;
    right: 30px;
    z-index: 2;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 50%;
    padding: 5px;

    @media only screen
    and (min-device-width: 320px)
    and (max-device-width: 667px)
    {
        right: 5px;
    }
}

.testimonial-card-edit {
    min-height: 100px;
}

.approved {
    color: green;
}

.unapproved {
    color: black;
}

.center-block {
    display: block;
    margin: 1rem auto;
    text-align: center;
}
</style>
